import React from "react";
import ContentRecoveryEmailSent from "../Content/ContentRecoveryEmailSent";

const RecoverPassword = () => {
  return (
    <div>
      <ContentRecoveryEmailSent />
    </div>
  );
};

export default RecoverPassword;
